import React, { useState } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import { Button, Input, Select } from "antd";
import { API_URLS } from "../../../api/apiUrls";
import { postApi, getApi } from "../../../api/api_instance";
// import { toast } from "react-hot-toast";
import { AcceptDialog } from "../../../components/Elements/DailogBox/AcceptDialog";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";

const CreateUsers = ({
  onOpen,
  onClose,
  onSuccess,
  onSave,
  onSuccessFalse,
}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [roleOptions, setRoleOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [showAcceptDialog, setShowAcceptDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    name: "",
    email: "",
    role: "",
    password: "",
    confirmPassword: "",
  });

  const fetchRoles = async () => {
    try {
      const response = await getApi({ apiUrl: API_URLS.ALL_ROLES });

      if (response.success && response.data?.docs?.length > 0) {
        const formattedRoles = response.data.docs.map((role) => ({
          label: role.Role,
          value: role._id,
        }));
        setRoleOptions(formattedRoles);
      } else {
        console.error("Failed to fetch roles.");
      }
    } catch (error) {
      console.error("Error fetching roles.");
    }
  };

  const handleSave = async () => {
    let isValid = true;
    const errors = {
      name: "",
      email: "",
      role: "",
      password: "",
      confirmPassword: "",
    };

    if (!name) {
      errors.name = "Name is required";
      isValid = false;
    }
    if (!email) {
      errors.email = "Email is required";
      isValid = false;
    }
    if (!role?.length) {
      errors.role = "At least one role is required";
      isValid = false;
    }
    if (!password) {
      errors.password = "Password is required";
      isValid = false;
    }
    if (!confirmPassword) {
      errors.confirmPassword = "Confirm Password is required";
      isValid = false;
    }
    if (password && confirmPassword && password !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
      isValid = false;
    }

    setErrorMessage(errors);
    if (!isValid) return;

    setLoading(true);
    try {
      const response = await postApi({
        apiUrl: API_URLS.CREATE_USER,
        data: { name, email, role, password },
      });

      if (response.success) {
        // toast.success("User created successfully!");
        onSave();
        onClose();
        // setShowAcceptDialog(true);
      } else {
        onSuccessFalse(response.message);
        onClose();
      }
    } catch (error) {
      onSuccessFalse(error.message);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setErrorMessage({});
    onClose();
  };

  const handleAcceptClose = () => {
    // setShowAcceptDialog(false);
    if (onSuccess) onSuccess();
  };

  return (
    <>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="800px">
        <div>
          <h3 className="text-xl font-bold text-[#06513D]">Add New User</h3>
        </div>

        <div className="rounded-xl border mt-8 px-12">
          <div className="mt-3 mb-4">
            <hr />
          </div>

          <div className="flex flex-col gap-6">
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Name"
              className="h-14 rounded-lg"
            />
            {errorMessage.name && (
              <div className="text-red-500 text-sm">{errorMessage.name}</div>
            )}

            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="h-14 rounded-lg"
            />
            {errorMessage.email && (
              <div className="text-red-500 text-sm">{errorMessage.email}</div>
            )}

            <Input.Password
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="h-14 rounded-lg"
            />
            {errorMessage.password && (
              <div className="text-red-500 text-sm">
                {errorMessage.password}
              </div>
            )}

            <Input.Password
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm Password"
              className="h-14 rounded-lg"
            />
            {errorMessage.confirmPassword && (
              <div className="text-red-500 text-sm">
                {errorMessage.confirmPassword}
              </div>
            )}

            <Select
              mode="multiple"
              placeholder="Select Role(s)"
              options={roleOptions}
              value={role}
              onChange={setRole}
              onFocus={fetchRoles}
              style={{ height: "40px" }}
              className="rounded-lg"
            />
            {errorMessage.role && (
              <div className="text-red-500 text-sm">{errorMessage.role}</div>
            )}
          </div>

          <div className="flex justify-center gap-6 p-5">
            <CustomButton
              buttonType="button"
              variant="cancel"
              buttonText="Cancel"
              onClick={handleCancel}
              className="text-base font-normal h-[50px] w-[160px]"
            />

            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText="Save"
              onClick={handleSave}
              className="text-base font-normal h-[50px] w-[160px]"
            />
          </div>
        </div>
      </DailogBox>

      {/* {showAcceptDialog && (
        <AcceptDialog
          open={showAcceptDialog}
          close={handleAcceptClose}
          heading="User Created"
          subheading="The new user has been successfully created."
          success={true}
        />
      )} */}
    </>
  );
};

export default CreateUsers;
